import React from 'react';

const Footer = () => {
  return (
    <footer className="footer mt-auto py-3">
      <div className="container">
        <div className="row text-center text-md-start">
          <div className="col-md-6 mb-2 mb-md-0">
            &copy; {new Date().getFullYear()} Mira Pearls. All rights reserved.
          </div>
          <div className="col-md-6 text-md-end">
            ABN: 67 165 491 609
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 